import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DropZone from './DropZone';
import { addFichier } from 'store/fichier/fichierActions';
import { removeFichier } from 'store/fichier/fichierActions';

import { updateDropZone } from 'store/common/commonActions';

class DropZoneContainer extends React.Component {

    constructor(props) {
        super(props);

        this.handleDrop = this.handleDrop.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    // Quand le composant est démonté, on nettoie le store
    componentWillUnmount() {
        const { cleanOnUnmount } = this.props;

        if (cleanOnUnmount) {
            const cleanedDropzone = { fichiers: [] };
            this.props.updateDropZone(cleanedDropzone);
        }
    }




    async handleDrop(acceptedFiles) {

        const { addFichier, maxNbOfFiles } = this.props;


        console.log("handleDrop", acceptedFiles);

        var dropZone = {
            fichiers: [...this.props.dropZone.fichiers, ...acceptedFiles]
        };


        if (maxNbOfFiles && dropZone.fichiers.length > maxNbOfFiles) {
            // Trop de fichier, on supprime les anciens

            let toRemove = dropZone.fichiers.slice(0, dropZone.fichiers.length - maxNbOfFiles);


            for (var j in toRemove) {

                if (toRemove[j].id) {
                    await this.props.removeFichier(toRemove[j].id);
                }

            }

            dropZone.fichiers = dropZone.fichiers.slice(dropZone.fichiers.length - maxNbOfFiles, dropZone.fichiers.length);

        }


        for (var i in dropZone.fichiers) {

            if (!dropZone.fichiers[i].id) {
                dropZone.fichiers[i].id = await addFichier(dropZone.fichiers[i]);
            }

        }


        // change it in the store
        this.props.updateDropZone(dropZone);



        this.props.onChange({
            target: {
                name: this.props.name,
                value: dropZone.fichiers.map(x => x.id),
                fichiers: [...dropZone.fichiers]
            }
        });
    }

    async handleDelete(id) {

        await this.props.removeFichier(id);

        var dropZone = {
            fichiers: this.props.dropZone.fichiers.filter(x => x.id !== id)
        };

        // change it in the store
        this.props.updateDropZone(dropZone);


        this.props.onChange({
            target: {
                name: this.props.name,
                value: dropZone.fichiers.map(x => x.id)
            }
        });
    }

    render() {
        const { dropZone, label, buttonLabel } = this.props;

        return (
            <DropZone onDrop={this.handleDrop} onDelete={this.handleDelete} files={dropZone.fichiers} label={label} buttonLabel={buttonLabel}/>
        );
    }
}



const mapStateToProps = (state, ownProps) => ({
    dropZone: state.common.dropZone
});

const mapDispatchToProps = dispatch => ({
    addFichier: file => dispatch(addFichier(file)),
    removeFichier: id => dispatch(removeFichier(id)),
    updateDropZone: dropZone => dispatch(updateDropZone(dropZone))
});

DropZoneContainer.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    buttonLabel: PropTypes.string,

    onChange: PropTypes.func.isRequired,
    maxNbOfFiles: PropTypes.number,

    cleanOnUnmount: PropTypes.bool
};

DropZoneContainer.defaultProps = {
    cleanOnUnmount: true
};

export default connect(mapStateToProps, mapDispatchToProps)(DropZoneContainer);